import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGeographicalZonesApiClient } from './i-geographical-zones-api.client';
import {
  IUpdateGeographicalZoneReqeust,
  ICreateGeographicalZoneRequest,
  IGeographicalZoneResponse,
} from '../dtos';
import { LocationManagementCollections } from '../../common/collections';
import { CollectionApiClient, IPaginationParameters, IPaginationResponse } from '../../../data-access';
import { ICreateGeographicalZoneResponse } from '../dtos/responses/create-geographical-zone.response';

@Injectable({
  providedIn: 'root'
})
export class GeographicalZonesApiClient implements IGeographicalZonesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(
      LocationManagementCollections.GeographicalZones,
      http
    );
  }

  get(
      paginationParameters?: IPaginationParameters
    ): Observable<IPaginationResponse<IGeographicalZoneResponse>> {
      return this.collectionApiClient.get({
        paginationParameters
      });
    }

  getById(id: string): Observable<IGeographicalZoneResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateGeographicalZoneRequest): Observable<ICreateGeographicalZoneResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateGeographicalZoneReqeust): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }
}
